(($, Drupal, drupalSettings) => {
  function playYoutubeVideo(iframe) {
    const youtubeCommand = window.JSON.stringify({
      event: "command",
      func: "playVideo",
    });

    if (undefined === iframe.contentWindow) {
      return;
    }

    iframe.contentWindow.postMessage(youtubeCommand, iframe.src);
  }

  function playVimeoVideo(iframe) {
    // eslint-disable-next-line no-undef
    const player = new Vimeo.Player(iframe);
    player.play();
  }

  /**
   * {inheritdoc}
   */
  Drupal.behaviors.videoParagraphPlay = {
    attach(context, settings) {
      $(".js-video-paragraph-open").on("click", function () {
        const that = $(this);
        const id = that.attr("id");
        const modal = $(`#modal_${id}`);
        const iframe = modal.find("iframe");

        modal.css("display", "block");

        if (modal.attr("provider") === "youtube" && iframe.length > 0) {
          playYoutubeVideo(iframe[0]);

          return;
        }

        if (modal.attr("provider") === "vimeo" && iframe.length > 0) {
          playVimeoVideo(iframe[0]);
        }
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
